import { TextField } from '@material-ui/core';
import React, { FunctionComponent } from 'react';

import Texto from '@infotrack/presentacion-componentes/texto';

import IDocumento from 'Infotrack@Modelos/negocioRefactor/entidades/repositorio/IDocumento';

interface ICampoDocumentoRelacionadoProps {
    deshabilitado: boolean;
    manejarCambioCampo: (nombreCampo: keyof IDocumento, nuevoValor: IDocumento[keyof IDocumento]) => any;
    valor: string;
    esTraslado: boolean;
}

const CampoDocumentoRelacionado: FunctionComponent<ICampoDocumentoRelacionadoProps> = ({
    deshabilitado,
    manejarCambioCampo,
    valor,
    esTraslado
}) => (
    <TextField
        disabled={deshabilitado}
        fullWidth
        label={
            esTraslado ? (
                <Texto id="FormularioDocumento.CampoDocumentoRelacionado.NumeroTicket" />
            ) : (
                <Texto id="FormularioDocumento.CampoDocumentoRelacionado.Nombre" />
            )
        }
        onChange={(event) => manejarCambioCampo('DocumentoRelacionado', event.target.value)}
        value={valor}
        id={`CampoDocumentoRelacionado-${valor}`}
        required={esTraslado}
    />
);

export default CampoDocumentoRelacionado;
